import { render, staticRenderFns } from "./M27_S13.vue?vue&type=template&id=5c49bb2f&scoped=true"
import script from "./M27_S13.vue?vue&type=script&lang=js"
export * from "./M27_S13.vue?vue&type=script&lang=js"
import style0 from "./M27_S13.vue?vue&type=style&index=0&id=5c49bb2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49bb2f",
  null
  
)

export default component.exports